var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletefaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6035 5.86426C13.7626 5.86439 13.9064 5.93448 14.0205 6.05176C14.1269 6.17714 14.1806 6.33256 14.165 6.49707C14.1647 6.55553 13.7401 11.9343 13.4971 14.1992C13.3448 15.5896 12.448 16.4339 11.1035 16.457C10.0698 16.4802 9.05934 16.4883 8.06445 16.4883C7.00823 16.4883 5.9753 16.4802 4.97266 16.457C3.67326 16.4259 2.7763 15.5664 2.63184 14.1992C2.38187 11.9267 1.96425 6.55695 1.95605 6.49707C1.94829 6.33258 2.00125 6.17713 2.1084 6.05176C2.21403 5.93436 2.36637 5.86426 2.52637 5.86426H13.6035ZM9.70996 0.511719C10.4159 0.511719 11.0469 1.00437 11.2295 1.70703L11.3604 2.29004C11.466 2.76521 11.8778 3.10156 12.3516 3.10156H14.6797C14.9903 3.10158 15.2489 3.35941 15.249 3.6875V3.99121C15.249 4.31144 14.9903 4.57713 14.6797 4.57715H1.44434C1.13288 4.57715 0.874023 4.31145 0.874023 3.99121V3.6875C0.874155 3.35939 1.13296 3.10156 1.44434 3.10156H3.77246C4.24546 3.10156 4.65726 2.76538 4.76367 2.29102L4.88574 1.74609C5.0753 1.00451 5.69862 0.511938 6.41211 0.511719H9.70996Z",
    fill: "#E71D36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletefaq);
export default __webpack_public_path__ + "static/media/deletefaq.115168b9df24561e51e274c1c8c30810.svg";
export { ForwardRef as ReactComponent };